import { Component, AfterViewInit } from '@angular/core';

import { Observable, of } from 'rxjs';

import { LoaderService } from 'src/app/_common/services/loader.service';

@Component({
    selector: 'aa-header-logo',
    templateUrl: './header-logo.component.html',
    styleUrls: [
        './header-logo.component.scss'
    ],
    standalone: false
})
export class HeaderLogoComponent implements AfterViewInit
{
    isLoading: Observable<boolean> = of(null);

    constructor(private loaderService: LoaderService) { }

    ngAfterViewInit ()
    {
        this.isLoading = this.loaderService.isLoading;
    }
}
